import styled from '@emotion/styled';
import { StyledButton } from '@selfserve/react-ui';
import { useTranslation } from 'react-i18next';

const StyledAddValueButton = styled(StyledButton)(
  ({ theme, disabled }: { theme?: any; disabled?: boolean }) => ({
    display: 'flex',
    color: theme.palette.primary.main,
    border: 'none',
    padding: theme.spacing(1),
    fontSize: theme.typography.pxToRem(14),
    fontWeight: '700',
    span: {
      position: 'relative',
      paddingLeft: '24px',
      '&::before': {
        WebkitMask: 'left 42% / auto no-repeat url("assets/add.svg")',
        position: 'absolute',
        left: '0',
        content: '""',
        background: disabled
          ? theme.palette.grey['400']
          : theme.palette.primary.main,
        width: '16px',
        height: '16px',
      },
    },
  })
);

interface Props {
  withoutMargin?: boolean;
  disabled?: boolean;
  onClick: () => void;
}

export const AddValueButton = (props: Props) => {
  const { t } = useTranslation();
  return (
    <StyledAddValueButton {...props} variant="borderless" isBorderless>
      {t('common.add-value')}
    </StyledAddValueButton>
  );
};
